export default __webpack_public_path__ + "static/media/guyDark.7c829c82.png";